module.exports = __webpack_public_path__ + "media/images/proof_links/colored/producthunt-e1e469dd1cf9bdaca412dcbe539344fc.svg";